export default {
  path: 'channel',
  label: '渠道管理',
  icon: 'fa fa-tasks',
  component: {
    render () {
      return <router-view />
    }
  },
  children: [
    {
      name: 'topup',
      path: 'topup',
      label: '订单查询',
      meta: {
        apiName: 'get_orderinfo',
      },
      component: () => import('../views/channel/topup')
    },
    {
      path: 'channel',
      label: '资源查询',
      meta: {
        apiName: 'get_resinfo',
      },
      component: () => import('../views/channel/channel')
    },
    {
      path: 'tob_send',
      label: '发货&绑定手机查询',
      meta: {
        apiName: 'get_vipflow',
      },
      component: () => import('../views/channel/tobSend')
    },
    {
      path: 'vip_usage_records',
      label: '会员使用记录',
      meta: {
        apiName: 'get_viewdata'
      },
      component: () => import('../views/channel/vipUsageRecords')
    },
    {
      path: 'content_coupon_usage_query',
      label: '内容现金券使用查询',
      meta: {
        apiName: 'get_tickets',
      },
      component: () => import('../views/channel/contentCouponUsageQuery')
    },
  ]
}
